import Navbar from './Components/Navbar';
import Button from './Components/Buttons';
import Stories from './Components/Stories';
import SearchForm from './Components/SearchForm';

function App() {
  return (
    <>
      {' '}
      <Navbar />
      <SearchForm />
      <Button />
      <Stories />
    </>
  );
}

export default App;
